import { render, staticRenderFns } from "./GallerySeries.vue?vue&type=template&id=0f7783e9&scoped=true&"
import script from "./GallerySeries.vue?vue&type=script&lang=js&"
export * from "./GallerySeries.vue?vue&type=script&lang=js&"
import style0 from "./GallerySeries.vue?vue&type=style&index=0&id=0f7783e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7783e9",
  null
  
)

export default component.exports